// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/jspdf.min.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import about from './routes/about';
import cars from './routes/cars';
import compare from './routes/compare';
import favorites from './routes/favorites';
import advancedSearch from './routes/advanced-search';
import privateLeasing from './routes/private-leasing';
import promotions from './routes/promotions';
import branches from './routes/branches';
import contact from './routes/contact-us';
import commercial from './routes/commercial';


/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  about,
  // car
  cars,
  // Favorites
  favorites,
  //Compare
  compare,
  //Advanced Search Page
  advancedSearch,
  //Private Leasing
  privateLeasing,
  //Promotions
  promotions,
  //branches
  branches,
  //contact-us
  contact,
  commercial
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js